import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled, { theme } from '../../../utils/Styling';
import UITile from 'UIComponents/tile/UITile';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon'; // @ts-expect-error no types

import useDisableBodyScroll from '../../../hooks/useDisableBodyScroll';
import UICaret from 'UIComponents/icon/icons/UICaret';
const OverlayContentUIFlex = styled(UIFlex).withConfig({
  displayName: "FullScreenModal__OverlayContentUIFlex",
  componentId: "ek3zsh-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:1111;background-color:white;transition:", ";opacity:", ";transform:", ";pointer-events:", ";overflow:auto;"], ({
  $open
}) => $open ? `transform ${theme.times.SLIDEIN_MODAL_TRANSITION_TIMING} ease-out` : `transform ${theme.times.SLIDEIN_MODAL_TRANSITION_TIMING} ease-out,
    opacity 0s ${theme.times.SLIDEIN_MODAL_TRANSITION_TIMING}`, ({
  $open
}) => $open ? '1' : '0', ({
  $open
}) => $open ? 'translateY(0%)' : 'translateY(100%)', ({
  $open
}) => $open ? 'auto' : 'none');
const StickyHeaderWrapper = styled.div.withConfig({
  displayName: "FullScreenModal__StickyHeaderWrapper",
  componentId: "ek3zsh-1"
})(["position:sticky;top:0;z-index:1;width:100%;color:", ";"], theme.colors.OLAF);
const ModalHeaderUITile = styled(UITile).withConfig({
  displayName: "FullScreenModal__ModalHeaderUITile",
  componentId: "ek3zsh-2"
})(["border-radius:0;background-color:", ";width:100%;border:none;padding:12px 20px;"], theme.colors.PANTERA);
const ModalContentUIBox = styled(UIBox).withConfig({
  displayName: "FullScreenModal__ModalContentUIBox",
  componentId: "ek3zsh-3"
})(["width:100%;"]);
const BackCaret = styled(UICaret).withConfig({
  displayName: "FullScreenModal__BackCaret",
  componentId: "ek3zsh-4"
})(["transform:rotate(180deg);height:12px;width:7px;margin-right:10px;"]);

const noop = () => {};

const FullScreenModal = (_ref) => {
  let {
    open = false,
    onCloseClick = noop,
    showCloseButton = true,
    backButton,
    children,
    headerContent,
    subheader
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["open", "onCloseClick", "showCloseButton", "backButton", "children", "headerContent", "subheader"]);

  useDisableBodyScroll(open);
  return /*#__PURE__*/_jsxs(OverlayContentUIFlex, Object.assign({
    $open: open,
    "data-test-is-showing": open,
    direction: "column"
  }, restProps, {
    children: [/*#__PURE__*/_jsx(StickyHeaderWrapper, {
      children: headerContent && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ModalHeaderUITile, {
          compact: true,
          children: /*#__PURE__*/_jsxs(UIFlex, {
            align: "center",
            children: [showCloseButton && /*#__PURE__*/_jsx(UIIconButton, {
              "data-test-id": "full-screen-modal-close",
              onClick: onCloseClick,
              placement: "right",
              use: "unstyled",
              children: backButton ? /*#__PURE__*/_jsxs("span", {
                children: [/*#__PURE__*/_jsx(BackCaret, {
                  color: theme.colors.OLAF
                }), 'Back']
              }) : /*#__PURE__*/_jsx(UIIcon, {
                color: theme.colors.OLAF,
                name: "remove"
              })
            }), headerContent]
          })
        }), subheader]
      })
    }), /*#__PURE__*/_jsx(ModalContentUIBox, {
      grow: 1,
      children: children
    })]
  }));
};

export default FullScreenModal;
export const IndentWrapper = styled.div.withConfig({
  displayName: "FullScreenModal__IndentWrapper",
  componentId: "ek3zsh-5"
})(["margin-left:20px;"]);
export const PanelItemUIFlex = styled(UIFlex).withConfig({
  displayName: "FullScreenModal__PanelItemUIFlex",
  componentId: "ek3zsh-6"
})(["padding:12px 20px 12px 0;border-bottom:1px solid ", ";font-weight:", ";", ";"], theme.colors.GREAT_WHITE, props => props.fontWeight || 400, props => props.hideBorder && 'border-bottom: none;');